module.exports = __webpack_public_path__ + "img/peopleHaveBorder.7b4fd38e.png";